/**
 * Shared resume styling. Duplicated in ResumeBuilder and PublicResume before,
 * which is how the two drifted apart.
 */

// Entry types are categorical, not ranked, and each already has an emoji.
// One neutral chip for all of them, so color stays available for the thing
// that actually varies in importance: validation strength.
export const ENTRY_TYPE_CLASS =
  "bg-gray-100 text-gray-600 dark:bg-white/5 dark:text-gray-400";

export const ENTRY_TYPE_DOT_CLASS = "bg-brand-violet text-white";

// Validation is a ladder, so it gets a ramp. Weight increases with evidence:
// unverified is gray, and each step up carries more violet.
export const VALIDATION_BADGES = {
  self_reported: {
    label: "Self-reported",
    color: "bg-gray-100 text-gray-500 dark:bg-white/5 dark:text-gray-400",
  },
  pending: {
    label: "Pending validation",
    color: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300",
  },
  domain_verified: {
    label: "Domain verified",
    color:
      "bg-brand-violet-tint/60 text-brand-violet dark:bg-brand-violet/10 dark:text-brand-violet-on-dark",
  },
  profile_corroborated: {
    label: "Profile corroborated",
    color:
      "bg-brand-violet-tint text-brand-violet dark:bg-brand-violet/20 dark:text-brand-violet-on-dark",
  },
  certificate_verified: {
    label: "Certificate verified",
    color: "bg-brand-violet text-white dark:bg-brand-violet dark:text-white",
  },
  institutionally_verified: {
      label: "Institutionally verified",
      color: "bg-brand-ink text-white dark:bg-white dark:text-brand-ink",
  },
};
